import {GetArrayFromRecursive, GetFlatArrayFromRecursive, normalizeItems} from '../../../core/helpers/CoreHelpers';

const initialState = {
    flat: [],
    items: [],
    filtered: [],
    select: [],
    menu: [],
    single: {},
    definition: {},
    parentWorkspaceId: null,
    title: null,
    loading: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'CONTENT_SET_DEFINITION':
            const {payload: {definition}} = action;

            return {
                ...state,
                definition: definition
            };
        case 'CONTENT_RESET':
            return initialState;
        case 'CONTENT_FILTER':
            return {
                ...state,
                filtered: action.payload.data
            };
        case 'GET_GLOBALS_FOR_WORKSPACE':
            return {
                ...state,
                items: action.payload.structure,
                filtered: action.payload.structure,
                menu: normalizeItems(action.payload.structure),
                flat: GetFlatArrayFromRecursive(action.payload.structure),
                select: GetArrayFromRecursive(action.payload.structure),
                parentWorkspaceId: action.payload.parentWorkspaceId
            };
        case 'CONTENT_SINGLE_SUCCESS':
            return {
                ...state,
                title: action.payload.title,
                definition: action.payload.definition,
                single: action.payload.data,
                loading:false
            };
        case "CONTENT_STRUCTURE_LOADING":
            return {
                ...state,
                loading:true
            };
        case 'CONTENT_STRUCTURE_SUCCESS':
            if (action.payload.skipStore === false) {
                return {
                    ...state,
                    items: action.payload.data,
                    filtered: action.payload.data,
                    menu: normalizeItems(action.payload.data),
                    flat: GetFlatArrayFromRecursive(action.payload.data),
                    select: GetArrayFromRecursive(action.payload.data),
                    parentWorkspaceId: action.payload.parentWorkspaceId,
                    loading:false,
                };
            } else {
                return {
                    ...state,
                    loading:false
                }
            }
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/store/reducers/content.js